/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Grid,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  TableHead,
  TableContainer,
  IconButton,
} from "@mui/material";
import Button from "../../../component/button";
import Delete from "@mui/icons-material/Delete";
import classes from "../packagedSolution/createPackage.module.css";
import { DeleteIconNew } from "../../../component/icons/icons";

const ComponentCustomers = (props) => {
  useEffect(() => {});
  const t = props.t;
  return (
    <div>
      <React.Fragment>
        <Grid container>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <TableContainer>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <span style={{ fontSize: "14px" }}>
                        {t("SELECTED_CUSTOMERS")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {props.readonly ? (
                        ""
                      ) : (
                        <Button
                          onClick={() => props.setShowCustomerDialog(true)}
                        >
                          {t("ADD_CUSTOMERS")}
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.customerListData.map((cust, index) => (
                    <TableRow key={index}>
                      <TableCell>{cust.accountName}</TableCell>
                      <TableCell align="right">
                        {props.readonly ? (
                          ""
                        ) : (
                          <Tooltip title={t("DELETE")}>
                            <IconButton
                              className="buttonSecondary"
                              onClick={() => props.deleteCustomer(cust)}
                            >
                              <DeleteIconNew />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  {props.customerListData.length === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan={2}>
                        {t("NO_CUSTOMER_SELECTED")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(ComponentCustomers),
);
